import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-type.enum';
import { CustomFormSelectorDTO } from 'src/app/model/observation/custom-forms/custom-form-selector-dto.model';
import { CustomFormsHelpersService } from 'src/app/services/custom-form-services/custom-forms-helpers/custom-forms-helpers.service';

const noop = () => { };

@Component({
    selector: 'paetep-custom-form-selector',
    templateUrl: './custom-form-selector.component.html',
    styleUrls: ['./custom-form-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CustomFormSelectorComponent)
        }
    ]
})
export class CustomFormSelectorComponent implements ControlValueAccessor {
    @Input() customFormSelectorDTOs: CustomFormSelectorDTO[] = [];
    @Input() busy: boolean = false;

    @Output() onCustomFormSelected: EventEmitter<CustomFormSelectorDTO | null> = new EventEmitter<CustomFormSelectorDTO | null>();
    @Output() onFieldSelected: EventEmitter<string> = new EventEmitter<string>();

    private _selectFormId: string | undefined;
    private _disabled: boolean = false;

    CustomFormType = CustomFormType;

    get selectedFormId(): string | undefined {
        return this._selectFormId;
    }

    set selectedFormId(v: string | undefined) {
        this._selectFormId = v;
        this.onTouchedCallback();
        this.onChangeCallback(this._selectFormId);
        this.onCustomFormSelected.emit(this.customFormSelectorDTOs.find(dto => dto.formID === v) ?? null);
    }

    get disabled() {
        return this._disabled;
    }

    set disabled(value: boolean) {
        this._disabled = value;
    }

    constructor(public customFormsHelpersService: CustomFormsHelpersService) { }

    writeValue(obj: any): void {
        this._selectFormId = obj;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onRowClicked(formID: string) {
        this.selectedFormId = this.selectedFormId === formID ? undefined : formID;
    }

    onFieldClicked = (field: string) => {
        this.onFieldSelected.emit(field);
    }

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

}
